module.exports = __webpack_public_path__ + "static/media/barbara3.ccf1dc27.mp3";